import React from 'react';

import Description from 'components/typography/Description';

const TitleInputDescription = () => {
  return (
    <Description>
      First, write the recipe <b>name</b>.
    </Description>
  );
};

export default TitleInputDescription;
